import { useMutation } from "@tanstack/react-query";
import { useModalStore } from "../../../lib/store/useModalStore";
import Button from "../../atoms/button";
import SelectBox from "../../atoms/select";
import type { CommunityReportRequest } from "../../../@apis/dto/request/community.request";
import { communityReport } from "../../../@apis/v1/community.service";
import React from "react";
import type { OnErrorResponse } from "../../../@apis/dto/response/common.response";

const REPORT_LABELS = [
  { label: "부적절한 콘텐츠", value: "INAPPROPRIATE_CONTENT" },
  { label: "거짓/사진 의심 정보", value: "FRAUDULENT_INFORMATION" },
  { label: "지적 재산권 침해", value: "INTELLECTUAL_PROPERTY_INFRINGEMENT" },
  { label: "광고/도배성", value: "ADVERTISING_SPAMMING" },
  { label: "혐오/모욕/폭력성 내용", value: "HATE" },
];

interface Props {
  type: "ARTICLE" | "COMMENT";
  relatedId: string | number;
  onClose: () => void;
}

export default function ReportDrawerLayout({
  type,
  relatedId,
  onClose,
}: Props) {
  const { openModal } = useModalStore();

  const [item, setItem] = React.useState<CommunityReportRequest>({
    reportType: type,
    relatedId: relatedId,
    reportIssueType: "INAPPROPRIATE_CONTENT",
  });

  const reportMutation = useMutation({
    mutationFn: (form: CommunityReportRequest) => communityReport(form),
    onSuccess: (res) => {
      const { success, error } = res;
      if (success) {
        onClose();
        openModal("REPORT_DIALOG");
      } else {
        alert(error?.message);
      }
    },
    onError: (err: OnErrorResponse) => {
      const { error } = err.response.data;

      openModal("ALERT_DIALOG", {
        title: "신고 실패",
        content: error?.message,
      });
    },
  });

  return (
    <section>
      <div className="p-5 bg-[#f5f5f5] rounded-[10px] w-full font-[500] text-[#888]">
        <p className="text-sm">
          저희는 모든 회원님들이 안전하고 쾌적하게 서비스를 이용하실 수 있도록
          24시간 모니터링을 통해 커뮤니티를 관리하고 있습니다. 신고하신 게시물은
          담당자가 신중하게 확인하여 부적절한 내용이 있을 경우 적절한 조치를
          신속히 진행할 예정입니다.
        </p>
      </div>
      <div className="mt-[25px] space-y-[20px]">
        <p className="font-bold">신고 사유</p>
        <SelectBox
          value={item.reportIssueType}
          className="w-full text-[0.7rem] placeholder:text-[0.7rem]"
          options={REPORT_LABELS}
          onChange={(e) =>
            setItem((prev) => ({ ...prev, reportIssueType: e.target.value }))
          }
        />
      </div>
      <div className="mt-[35px] flex-row w-full gap-[10px] py-[15px]">
        <Button
          className="w-full"
          variant={"white"}
          label="취소"
          onClick={onClose}
        />
        <Button
          className="w-full"
          variant={"black"}
          label="신고하기"
          onClick={() => reportMutation.mutate(item)}
        />
      </div>
    </section>
  );
}
